import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from 'vue-apexcharts'
import VueResource from 'vue-resource'
import Vuetify from 'vuetify'
import Moment from 'vue-moment';
import Loading from 'vue-loading-overlay';
import VueTheMask from 'vue-the-mask'
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import VueEditor from 'vue2-editor'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import HighchartsVue from 'highcharts-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMaterial from 'vue-material'
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
import decode from 'jwt-decode'

let token = localStorage.getItem("token_adm_comprodonto");

// const socket = io('http://localhost:3001', {query: {'token': (token) ? decode(localStorage.getItem('token_adm_comprodonto')).usr.id : '' } });

// Vue.use(VueSocketIOExt, socket);



 
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-slot-calendar/lib/calendar.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue-material/dist/vue-material.min.css'

Vue.use(VueApexCharts)
Vue.use(HighchartsVue)
Vue.use(VueResource)
Vue.use(Vuetify)
Vue.use(Moment)
Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(DatePicker)
Vue.use(VueEditor)
Vue.use(VueSweetalert2);
Vue.use(VueMaterial)
Vue.component('v-select', vSelect)
Vue.component('apexchart', VueApexCharts)
Vue.component('loading', Loading)
Vue.component(VueQrcode.name, VueQrcode);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
